// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2sLXD","left":"styles_left__1gD5V","desktopActions":"styles_desktopActions__yIFaO","title":"styles_title__3fvm6"};